import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { CommunitymanagerService } from '../cm-dashboard/communitymanager.service';
import { LeadService } from '../../lead/lead.service';
import { DesignerService } from '../../designer/designer.service';
import { Routes, RouterModule , Router,ActivatedRoute} from '@angular/router';
import { CategoryPipe } from '../../../shared/category.pipe';
import { SortPipe } from '../../../shared/sort.pipe';
import { NgPipesModule } from 'ngx-pipes';
import { SchedulerService } from '../../scheduler/scheduler.service';
declare var $:any;

@Component({
  selector: 'app-cm-wip',
  templateUrl: './cm-wip.component.html',
  styleUrls: ['./cm-wip.component.css'],
  providers: [CommunitymanagerService,SchedulerService,DesignerService,LeadService]
})
export class CmWipComponent implements OnInit {
  CMId : string;
  usersList;
    userData ;
  assignedDesignerId = [];
  projecttask_name = [];
  projecttask_id = [];
  projecttask_duration = [];
  projecttask_action_point = [];
  projecttask_process_owner = [];
  projecttask_percent_completion = [];
  projecttask_previous_dependency = [];
  projecttask_remarks =[];
  projecttask_start_date  = [];
  projecttask_end_date = [];
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
  errorMessagemodal : string;
  erroralertmodal = false;
  successalertmodal = false;
  successMessagemodal : string;
  updateProjectTaksForm: FormGroup;
  startDateForGanttChart : Date;
  endDateForGanttChart : Date;
  updateLeadquestionnaireForm : FormGroup;
  designerBookingForm1: FormGroup;
  project:any;
  lead_status;
  designersList;
  statusDetails: any = {};
  wipList:any = [];

  custom_status:string;
  headers_res;
  per_page;
  total_page;
  current_page;
  search_value: any;
  current_user_id: any;
  todayDate: any;
  dropLeadForm:FormGroup;
  userRole :any
  cm_list: any;
  sm_list :any
  role: string;
  CM: any;
  SM: any;
  constructor(
    private loaderService : LoaderService,
    private cmService : CommunitymanagerService,
    private leadService: LeadService,
    private formBuilder:FormBuilder,
    private schedulerService : SchedulerService,
    private designerService:DesignerService,
    private route:ActivatedRoute
  ) { 
      this.CMId = localStorage.getItem('userId');
      this.userRole = localStorage.getItem('user');
    }


  onKey(event: any) { // without type info
    this.search_value = event.target.value ;
    var  i=0;
    if(true){
      this.getWipList('',this.search_value);
      i++;
    }

  }
  searchCM:any;
  searchSM:any;
  filterbyCm(val , type){

    if(type == 'cm'){
      this.searchCM=val ;
      this.getWipList('',this.search_value,this.searchCM);
    }else{
      this.getCMList() 
      this.searchSM = val
      this.searchCM=null ;
      this.getWipList('',this.search_value,this.searchSM);
    }
  }
  

  // getCMList(cmid){
  //   this.cmService.getFiterListOfCM(cmid).subscribe(
  //     (res)=>{
  //       this.cm_list=res["cms"]
  //       this.sm_list = res["sales_managers"]
  //     }
  //   )

  // }
 
  ngOnInit() {

    this.role = localStorage.getItem('user');
    this.route.queryParams.subscribe(params => {
        this.custom_status = params['customer_status'];
        
      });
    this.route.queryParams.subscribe(params => {
        this.designer_id = params['designer_id'];
     });
     this.route.queryParams.subscribe(params => {
      this.searchCM = params['searchCM'];
      
    });

    this.route.queryParams.subscribe(params => {
      this.searchSM = params['searchSM'];
      
    });


    this.getCMList()
    // this.getSMList()
    this.getWipList(1);
    this.loaderService.display(true);
    this.current_user_id = localStorage.getItem('userId');
    this.todayDate = new Date().toISOString().substring(0,16);
    this.createForm();
  }
  direction: number;
  isDesc: boolean = true;
  column: string;
  // Change sort function to this: 
  sort(property){
      this.isDesc = !this.isDesc; //change the direction    
      this.column = property;
      this.direction = this.isDesc ? 1 : -1; 
  }    
  page_number;
  score:any ='';
  showChangeStatus:any=true;
  getWipList(page?,search?,CM?){
    var ppmr  ;
    if(this.filtercol1Val == "pending"){
       ppmr = "pending";
    } 
    else{
      ppmr ="";
    }

    if(this.CMId === undefined){
      this.CMId = ''
    }

    if(this.custom_status === undefined){
      this.custom_status = ''
    }

    if(this.designer_id === undefined){
      this.designer_id = ''
    }

    if(this.search_value === undefined){
      this.search_value = ''
    }

    if(this.searchCM === undefined || this.searchCM == null){
      this.CM = ''
    }
    else{
      this.CM=this.searchCM
    }
    if(this.searchSM === undefined || this.searchSM == null){
      this.SM = ''
    }
    else{
      this.SM=this.searchSM
    }
    if(this.score === undefined){
      this.score = ''
    }
    if(this.bu_approval === undefined){
      this.bu_approval = ''
    }

    if(page === undefined){
      page = 1
    }
     
    this.page_number = page;
    this.loaderService.display(true);
    this.cmService
      .getWipList(
        this.CMId,
        this.custom_status,
        this.designer_id,
        page,
        this.search_value,
        this.CM,
        this.SM,
        ppmr,
        this.score,
        this.bu_approval
      )
      .subscribe(
        (res) => {
          this.headers_res = res.headers._headers;
          this.per_page = this.headers_res.get("x-per-page");
          this.total_page = this.headers_res.get("x-total");
          this.current_page = this.headers_res.get("x-page");

          res = res.json();
          // this.usersList = res.leads;
          this.wipList = res.leads;
          // console.log(this.wipList[0].project_status);
          if(this.wipList.length>0){
            this.showChangeStatus=this.wipList[0].project_status;
                  }
          this.loaderService.display(false);
        },
        (err) => {
          this.loaderService.display(false);
        }
      );
  }

  bu_approval :any
  buheadApprovalFilter(){
    this.bu_approval = true
    this.getWipList()
  }


  onCallbackChange2(){
      this.loaderService.display(true);
      $("#statusModal2").modal("hide");
      this.statusDetails['remarks']= $("#inactive_remarks").val();
      this.statusDetails['reason_for_lost']=$("#inactive_reason").val();
      this.dropdownDropType='Select Reason';
      this.updateNewStatus();
  }  

  getCMList(){
    if(this.role == 'area_sales_manager'){

      this.cmService.getFilterListofWIPCM(this.searchSM).subscribe(
        (res)=>{
          this.cm_list=res["cms"]
          this.sm_list=res["sales_managers"]
        },
        (err) => {
          
        }
      )
    } else{

      if(this.role == 'deputy_general_manager'){

        this.cmService.getFilterListofWIPCMForDM().subscribe(
          (res)=>{
            this.cm_list=res;
          },
          (err) => {
            
          }
        )

      }

     

    }
   

  }

  // getSMList(){
  //   this.leadService.getSalesManagerList().subscribe(
  //     (res) => {
  //       this.sm_list=res["sales_managers"]

  //     },
  //     (err) => {
  //       console.log(err)
  //     }
  //   )
  // }

  callResponse: any;
  callToLead(contact){
    this.loaderService.display(true);
    this.designerService.callToLead(localStorage.getItem('userId'), contact).subscribe(
        res => {
           this.loaderService.display(false);
          if(res.inhouse_call.call_response.code == '403'){
            this.erroralert = true;
            this.errorMessage = JSON.parse(res.message.body).RestException.Message;
            setTimeout(function() {
                 this.erroralert = false;
            }.bind(this), 10000);
            //JSON.parse(temp1.body).RestException.Message
          } else {
            this.callResponse =  JSON.parse(res.inhouse_call.call_response.body);
            this.successalert = true;
            this.successMessage = 'Calling from - '+this.callResponse.Call.From;
            setTimeout(function() {
                 this.successalert = false;
            }.bind(this), 10000);
          }
        },
        err => {
          this.loaderService.display(false);
        }
     );
  }

  projectId:any;
  customerId:any;
  onStatusChange(projectId,customerId, status){
    this.statusDetails["customer_status"] = status;
    // this.statusDetails["customer_remarks"] = "";
    // this.statusDetails["customer_meeting_time"] = "";
    this.statusDetails["customer_id"] = customerId;
    this.statusDetails["project_id"] = projectId;
    this.projectId= projectId;
    this.customerId=customerId;
    this.loaderService.display(true);

    if(this.statusDetails["customer_status"] == "on_hold"){
      $("#followup-details").val(new Date(new Date().getTime() + 330*60000).toJSON().slice(0,19));
      this.loaderService.display(false);
      $("#statusModal").modal("show");
    }
    else if(this.statusDetails["customer_status"] == "inactive"){
        
        this.loaderService.display(false);
        $("#statusModal2").modal("show");
      }
      
    else{
      this.updateNewStatus();
    }
  }

  onSubStatusChange(projectId,customerId, substatus){
    this.statusDetails["sub_status"] = substatus;
    // this.statusDetails["customer_remarks"] = "";
    // this.statusDetails["customer_meeting_time"] = "";
    this.statusDetails["customer_id"] = customerId;
    this.statusDetails["project_id"] = projectId;
    this.projectId= projectId;
    this.customerId=customerId;
    this.loaderService.display(true);
    
    this.designerService.subStatusUpdate(this.statusDetails,this.CMId).subscribe(
      res => {

        this.getWipList(1);
        this.successalert = true;
        this.successMessage = 'Status updated successfully!';
        setTimeout(function() {
               this.successalert = false;
          }.bind(this), 2000);
          
      },
      err => {

        this.erroralert = true;
        this.loaderService.display(false);
          this.errorMessage = JSON.parse(err['_body']).message;
          setTimeout(function() {
               this.erroralert = false;
          }.bind(this), 2000);

      }
    )

  }

  isProjectInWipAndActive(status):boolean {
    var wip_array = ["wip", "pre_10_percent", "10_50_percent", "50_percent", "installation"]
    if(wip_array.includes(status)){
      return true
    }
    else{
      return false
    }
  }

  onCallbackChange(){
    this.loaderService.display(true);
    $("#statusModal").modal("hide");
    this.statusDetails["customer_meeting_time"] = $("#followup-details").val();
    this.statusDetails['reason_for_lost']=this.dropdownDropType1;
    this.statusDetails['remarks']= $("#followup_remarks").val();
    this.updateNewStatus();
    this.remarks_reopening = '';
    this.date_reopening = '';
    this.dropdownDropType1 = '';
  }
  resendMagicLink(data:any){
    this.designerService.resendmagic(data).subscribe(res=>{ 
      this.successalert = true;
       this.successMessage = 'Magic Link successfully Sent to Customer Email'; 
       setTimeout(function()
        { this.successalert = false;
         }.bind(this), 4000); }) 
       }

  updateNewStatus(){
    this.designerService.statusUpdate(this.statusDetails,this.CMId).subscribe(
      res => {

        this.getWipList(1);
        this.successalert = true;
        this.successMessage = 'Status updated successfully!';
        setTimeout(function() {
               this.successalert = false;
          }.bind(this), 2000);
          
      },
      err => {

        this.erroralert = true;
        this.loaderService.display(false);
          this.errorMessage = JSON.parse(err['_body']).message;
          setTimeout(function() {
               this.erroralert = false;
          }.bind(this), 2000);

      }
    )
  }


  openpopup(event, id) {
    var thisobj=this;
    $(event.target).popover({
      trigger:'hover'
    });
   
    //$(this).popover();
    $(function () {
      $('.pop').popover({
        trigger:'hover'
      })
    }) 
  }

  
  ngOnDestroy(){
    $(function () {
      $('.pop').remove();
    })
  }
  
  ngAfterViewInit(){

    $(function () {
         $('.pop').popover({
           trigger:'hover'
         })
    })
  }

  to_date;
  from_date;
  filtercol1Val : any = 'all';
  filterColumDropdownChange(colVal) {
    this.bu_approval = ''
    // this.from_date = undefined;
    // this.to_date = undefined;
    
    if (colVal == "all" || colVal == "pending") {
      this.filtercol1Val = colVal;
      this.designer_id = "";
      this.from_date = "";
      this.to_date = "";
      this.score = "";
      document.getElementById("fromDateFilter").classList.add("d-none");
      document.getElementById("toDateFilter").classList.add("d-none");
      document
        .getElementById("designer_list")
        .setAttribute("style", "display:none");
    } else if (colVal == "list_designer") {
      this.filtercol1Val = colVal;
      this.myDesigners();
      document.getElementById("fromDateFilter").classList.add("d-none");
      document.getElementById("toDateFilter").classList.add("d-none");
      document
        .getElementById("designer_list")
        .setAttribute("style", "display:inline-block");
      this.score = "";
    }
    else{
      this.designer_id = "";
      this.from_date = "";
      this.to_date = "";
      this.score = true
      this.filtercol1Val = 'all';
      document.getElementById("fromDateFilter").classList.add("d-none");
      document.getElementById("toDateFilter").classList.add("d-none");
      document
        .getElementById("designer_list")
        .setAttribute("style", "display:none");
        this.filterSubmit();
    }
  }

  my_designers;
  designer_id;
  myDesigners(){
    this.loaderService.display(true);
    this.cmService.getListOfDesigner(this.current_user_id).subscribe(
      res => {
        this.my_designers = res.users;
        this.designer_id = this.my_designers[0]["id"];
        
        this.loaderService.display(false);
      },
      err => {
        
        this.loaderService.display(false);
      }
    );
  }

  onDesignerFilterSelect($event){
    this.designer_id = $event.target.value
  }

  filterSubmit(){
    if (this.filtercol1Val == "all" || this.filtercol1Val =="pending") {
      this.getWipList(1, this.search_value);
    } else {
      this.getWipList(this.page_number);
    }
  } 
  dropdownDropType;
    submitDropLeadType(type){
      this.dropdownDropType=type;
      //this.dropLeadForm.controls['drop_reason'].setValue(this.dropdownDropType);
    }

    remarks_reopening;
    date_reopening;
    dropdownDropType1;
    submitDropLeadType1(type) {
      this.dropdownDropType1=type;
    }
  
  project_id;
  project_id2;
  email_id;
  reschedule_onholdevent(event,event2,email) {
    console.log(email);
    email = email.user_reference?email.user_reference.email
    :email.email

    this.project_id = event;
    this.project_id2 = event2;
    this.email_id = email;
    console.log(email);
    $("#modal_date").val(new Date(new Date().getTime() + 330*60000).toJSON().slice(0,19));
    $("#statusModal3").modal("show");
    }
  date_details;
  remarks_details;
  reschedule_onhold() {
    this.leadService.updateonholdEvent(this.project_id2,this.project_id,this.date_details, this.remarks_details,this.email_id).subscribe(res => {
      this.successalert = true;
      this.successMessage = 'Rescheduled successfully!';
      setTimeout(function() {
             this.successalert = false;
      }.bind(this), 2000);
    $("#statusModal3").modal("hide");
      this.getWipList(1,'');
    },
    err => {

      this.erroralert = true;
      this.loaderService.display(false);
        this.errorMessage = 'Failed to Update';
        setTimeout(function() {
             this.erroralert = false;
        }.bind(this), 2000);

    })
  }
  
  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }


  createForm(){
      this.dropLeadForm = this.formBuilder.group({
        reason: new FormControl("",Validators.required),
        reason_for_drop:new FormControl("",Validators.required),
        reason_remark:new FormControl("")
      })
  }
  dropdownDropreason;
  submitDropLeadType2(type){    
    this.dropdownDropType=type;
    this.dropLeadForm.controls['reason_for_drop'].setValue(this.dropdownDropType);
    this.dropdownDropreason = undefined;
    this.dropLeadForm.controls['reason'].setValue("");
    this.dropLeadForm.controls['reason_remark'].setValue("");
    if(type == 'others'){
    this.dropLeadForm.controls['reason_remark'].setErrors(null);
    this.dropLeadForm.controls['reason_remark'].updateValueAndValidity
    }
  }

  dropdownDropremark;
  submitDropLeadTypeReason(type){
    console.log("jjjj");
    this.dropdownDropreason=type;
    this.dropdownDropremark = undefined;
    this.dropLeadForm.controls['reason'].setValue(type);
    console.log(this.dropLeadForm.controls['reason'].value)
    this.dropLeadForm.controls['reason_remark'].setValue("");
    if(type == 'fhi' || type == 'phi' || type == 'only_on_site-services_execution' ){
      this.dropLeadForm.controls['reason_remark'].setValidators(Validators.required)
      this.dropLeadForm.controls['reason_remark'].updateValueAndValidity
    } else{
      this.dropLeadForm.controls['reason_remark'].setErrors(null)
      this.dropLeadForm.controls['reason_remark'].updateValueAndValidity

    }
  }

  submitDropLeadTypeSub(type){
    this.dropdownDropremark=type;
    this.dropLeadForm.controls['reason_remark'].setValue(type);
  }

  abcd:any={};
  dropleadId;
  updateStatus(formval){
    $("#statusModal2").modal("hide");
    this.abcd=formval;
    this.loaderService.display(true);
    this.designerService.updateCancelledStatus(this.CMId,this.abcd,this.customerId,this.projectId).subscribe(
        res => {

          this.getWipList(1);
          this.successalert = true;
          this.successMessage = 'Status updated successfully!';
          setTimeout(function() {
                 this.successalert = false;
            }.bind(this), 2000);
            
        },
        err => {
  
          this.erroralert = true;
          this.loaderService.display(false);
            this.errorMessage = JSON.parse(err['_body']).message;
            setTimeout(function() {
                 this.erroralert = false;
            }.bind(this), 2000);
  
        }
      );
  }
  onCancelRemarkModalClose(){
    this.dropLeadForm.controls['reason_for_drop'].setValue('');
    this.dropLeadForm.controls['reason'].setValue("");
    this.dropLeadForm.controls['reason_remark'].setValue("");
    this.dropdownDropreason='';
  }
  leadApproveReject(id , status){
    this.leadService.leadCancelApproveReject(id , status).subscribe(res => {
      this.successalert = true;
      this.successMessage = res.message;
      setTimeout(function() {
             this.successalert = false;
        }.bind(this), 2000);
        this.getWipList(1);
    }, err => {
      console.log(err)
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-wip/cm-wip.component.ts